import axios, { AxiosInstance } from 'axios';
import { useRoute } from 'vue-router';

import { authService } from '../auth';
import { config } from '../config';

import { applyApiHostRewrite } from './dev';

let api: AxiosInstance;

export function coreApi(): AxiosInstance {
	if (api) {
		return api;
	}

	api = axios.create({
		baseURL: config().getBaseURL()
	});

	if (process.env.NODE_ENV === 'development') {
		applyApiHostRewrite(api);
	}

	api.interceptors.request.use(request => {
		request.headers.authorization = authService().getAuthorizationHeader();
		request.headers['Visitor-Fingerprint-Id'] =
			authService().getVisitorFingerprintId();

		return request;
	});

	api.interceptors.response.use(
		async config => config,
		async error => {
			const route = useRoute();
			if (route.meta.isPublic) {
				return Promise.reject(error);
			}
			if (error.response?.status === 401) {
				const authSvc = authService();

				if (error.response?.data?.type === 'suspended_visitor_fingerprint_id') {
					await authSvc.handleSuspendedFingerprint();
					return Promise.reject(error);
				}

				// Attempt to refresh the token
				await authSvc.refreshAccessToken(true);

				// Retry the original request with the new token
				const originalReq = error.config;
				originalReq.headers.authorization = authSvc.getAuthorizationHeader();

				return api(originalReq);
			}
			return Promise.reject(error);
		}
	);

	return api;
}
